import React from 'react'
import restaurantphotonew from "../images/MULTICUISINE RESTAURANT vilasclubresort.jpg";
import restaurantreceptionnew from "../images/Restro Reception new 2.jpg"
import restaurantphotonredecor from "../images/Vojan Restaurant new decor.jpg";




import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


function Multicuisine() {
  return (
    <div>
           <div className='album py-0'>
                <div className='container'>
                    <div className="row">
                            <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                                <Zoom>
                                <img src={restaurantphotonew} className="card-img-top imge2" alt="restaurantphoto"/>
                                </Zoom>
                                <div className="overlay1"> MULTICUISINE AREA </div>
                            </div>
                        </div>
                            <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                                <Zoom>
                                <img src={restaurantreceptionnew} className="card-img-top imge2" alt="restaurantreception"/>
                                </Zoom>
                                <div className="overlay1"> MULTICUISINE AREA </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                                <Zoom>
                                <img src={restaurantphotonredecor} className="card-img-top imge2" alt="restaurantphoto"/>
                                </Zoom>
                                <div className="overlay1"> MULTICUISINE AREA </div>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Multicuisine